import localScaleManager from "../../../../helpers/LocalScaleManager";
import Seat from "./seat";

export class SeatManager {
  /**
   * @param scene {Phaser.Scene}
   * @param table {Table} needs for click on seat plus
   * @param seatNumber {number} Seat index in the list of table seats needs for click on seat plus
   * @param visibility {boolean} to show or hide when construct
   */
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.positionsList = [];
    this.positionsAreChanging = false;
  }
  /**
   * @param position {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" } r: right, l: left, t: top, b: bottom, c: center
   * @param serverPosition {number}
   * @param isMyTable {boolean} self player seat or not
   * @param idle {boolean} player seat or not
   * @param cardsType {"2-cardDeck" | "4-cardDeck"| "5-cardDeck"} cards Type based on table type
   */
  createSeat(position, serverPosition, isMyTable, idle, cardsType) {
    this.test = this.test + 1;
    return new Seat(
      this.scene,
      this.table,
      position,
      serverPosition,
      isMyTable,
      idle,
      cardsType,
      this.test
    );
  }
  visibilityControls(visibility) {
    this.visibility =
      typeof visibility === "undefined" ? this.visibility : visibility;
    // this.chips.chipsVisibilityControls(this.visibility);
    // this.dealer.visibilityControls(this.visibility);
    // seat.visibilityControls(this.visibility);
  }

  /**
   * change seats position based on
   * @param position {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" }
   * @param {*} useTween
   */
  async changeSeatsPositionsBy(position, useTween) {
    if (!this.positionsAreChanging) {
      let nextPosition,
        seatTweenCompleted = 0,
        array = [];
      this.positionsAreChanging = true;
      const distanceToSelfPlayer = this.getDistanceToSelfPlayer(position);
      // console.log(distanceToSelfPlayer);
      return new Promise((resolve) => {
        this.table.seats.forEach((seat) => {
          nextPosition = this.getNextPosition(
            this.getPosition(seat.position).position,
            distanceToSelfPlayer
          );
          // console.log(nextPosition);
          seat.changePosition(nextPosition, useTween).then(() => {
            seatTweenCompleted++;
            if (seatTweenCompleted === this.table.seats.length) {
              this.positionsAreChanging = false;
              resolve();
            }
          });
          seat.position = nextPosition.position;
        });
      });
    }
  }
  setPositionsList() {
    this.positionsList = [];
    this.table.seats.forEach((seat) => {
      this.positionsList.push({
        position: seat.position,
        boxX: seat.box.x,
        boxY: seat.box.y,
        dealerX: seat.dealerX,
        dealerY: seat.dealerY,
        betX: seat.playerBet.chips.x,
        betY: seat.playerBet.chips.y,
      });
    });
  }
  idleSeats(seats) {
    seats.forEach((seat) => {
      if (seat) seat.setIdle();
    });
  }
  /**
   * This function is to check weather away and fold statuses should be shown or not
   * Since setIdle function doesn't make them hidden.
   * @param seats
   * @param state {string}
   */
  checkActionsStatus(seats, state) {
    let fold, away;
    seats.forEach((seat) => {
      fold = seat.actions.fold;
      away = seat.actions.away;
      if (!seat.playerId) {
        seat.actions.hide(fold, 0);
        seat.actions.hide(away, 0);
      } else if (state === "Idle") {
        seat.actions.hide(fold, 0);
      }
    });
  }
  /**
   * @param currentPosition {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" }
   * @param step {number} chand position ba'di
   * @return {Position}
   */
  getNextPosition(currentPosition, step) {
    let nextPosition = "";
    if (
      this.getPositionIndex(currentPosition) + step >=
      this.positionsList.length
    ) {
      nextPosition =
        this.positionsList[
          this.getPositionIndex(currentPosition) +
            step -
            this.positionsList.length
        ];
    } else {
      nextPosition =
        this.positionsList[this.getPositionIndex(currentPosition) + step];
    }
    return nextPosition;
  }
  /**
   * @param currentPosition {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" }
   * @return {number}
   */
  getDistanceToSelfPlayer(currentPosition) {
    return this.positionsList.length - this.getPositionIndex(currentPosition);
  }

  /**
   * @param position {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" }
   * @return {Seat}
   */
  getSeatByPosition(position) {
    return this.table.seats.find((seat) => seat.position === position);
  }

  /**
   * @param position {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" }
   * @return {Object}
   */
  getPosition(position) {
    return this.positionsList.find((pos) => pos.position === position);
  }

  /**
   * @param position {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" }
   * @return {number}
   */
  getPositionIndex(position) {
    return this.positionsList.findIndex((pos) => pos.position === position);
  }

  /**
   * @param index{number}
   * @return {string}
   */
  getPositionByServerPosition(index) {
    return this.table.seats.find((seat) => seat.serverPosition === index)
      .position;
  }
  /**
   * @param index{number}
   * @return {Seat}
   */
  getSeatByServerPosition(index) {
    return this.table.seats.find((seat) => seat.serverPosition === index);
  }

  /**
   * @return {boolean}
   */
  hasSelfPlayerSat() {
    return !!this.table.seats.find((seat) => seat.isMyTable === true);
  }
  getSelfPlayerSeat() {
    return this.table.seats.find((seat) => seat.isMyTable === true);
  }
  /***
   * @param seat {Seat}
   * @param reposition {Boolean}
   */
  positionControls(seat, reposition) {
    const width = this.table.displayWidth;
    const height = this.table.displayHeight;
    const initX = this.table.x;
    const initY = this.table.y;
    let boxX,
      boxY,
      boxWidth,
      boxHeight,
      dealerSize,
      dealerX,
      dealerY,
      chipsX,
      chipsY,
      seatPositions;
    const boxSize = seat.isMyTable ? width * 0.245 : width * 0.19;
    // const boxSize = width * .19;
    localScaleManager.scaleSprite(seat.box, boxSize, boxSize, 0, 1, true);
    boxWidth = seat.box.displayWidth;
    boxHeight = seat.box.displayHeight;
    dealerSize = boxWidth / 5;
    // if(seat.isMyTable){
    // if (this.hasSelfPlayerSat()) {
    //   switch (seat.position) {
    //     case "cb": {
    //       boxX = initX + width / 2 - boxWidth + boxWidth / 10;
    //       boxY = initY + height - boxHeight * 2.5 + boxHeight / 15;
    //       dealerSize = boxWidth / 6.5;
    //       dealerX = boxX + this.table.dealer.displayWidth / 15;
    //       dealerY = boxY - boxHeight + this.table.dealer.displayHeight / 13;
    //       chipsX = boxX + boxWidth / 3.57;
    //       chipsY = boxY - (boxHeight * 21) / 20;
    //       break;
    //     }
    //     case "lb2": {
    //       boxX = initX + boxWidth / 4;
    //       boxY = initY + (height * 13) / 22;
    //       dealerX = boxX + boxWidth;
    //       dealerY = boxY + boxHeight / 4;
    //       chipsX = boxX + boxWidth + boxWidth / 6;
    //       chipsY = boxY - boxHeight / 3;
    //       break;
    //     }
    //     case "lb1": {
    //       boxX = initX + boxWidth / 5;
    //       boxY = initY + (height * 33) / 70;
    //       dealerX = boxX + boxWidth + boxWidth / 10;
    //       dealerY = boxY - boxHeight / 10;
    //       chipsX = boxX + boxWidth;
    //       chipsY = boxY + boxHeight / 3;
    //       break;
    //     }
    //     case "lt1": {
    //       boxX = initX + boxWidth / 5;
    //       boxY = initY + height / 4 + height / 13;
    //       dealerX = boxX + boxWidth;
    //       dealerY = boxY + boxHeight / 2;
    //       chipsX = boxX + boxWidth * 0.8;
    //       chipsY = boxY + boxHeight;
    //       break;
    //     }
    //     case "lt2": {
    //       boxX = initX + boxWidth * 0.6;
    //       boxY = initY + height / 6.5;
    //       dealerX = boxX + boxWidth + boxWidth / 6;
    //       dealerY = boxY + boxHeight / 3;
    //       chipsX = boxX + boxWidth * 0.9;
    //       chipsY = boxY + boxHeight - boxHeight / 20;
    //       break;
    //     }
    //     case "ct": {
    //       boxX = initX + (width - boxWidth) / 2;
    //       boxY = initY + height / 9;
    //       dealerX = boxX + boxWidth;
    //       dealerY = boxY + boxHeight / 1.5;
    //       chipsX = boxX + boxWidth / 20;
    //       chipsY = boxY + boxHeight + boxHeight / 4.5;
    //       break;
    //     }
    //     case "rt2": {
    //       boxX = initX + width * 0.7;
    //       boxY = initY + height / 5.6;
    //       dealerX = boxX - boxWidth / 15;
    //       dealerY = boxY + boxHeight / 0.9;
    //       chipsX = boxX - boxWidth * 0.7;
    //       chipsY = boxY + boxHeight / 1.8;
    //       break;
    //     }
    //     case "rt1": {
    //       boxX = initX + width * 0.75;
    //       boxY = initY + height / 2.45;
    //       dealerX = boxX - boxWidth / 5;
    //       dealerY = boxY + boxHeight / 1.1;
    //       chipsX = boxX - boxWidth * 0.8;
    //       chipsY = boxY + boxHeight / 3.2;
    //       break;
    //     }
    //     case "rb1": {
    //       boxX = initX + width * 0.77;
    //       boxY = initY + height / 1.79;
    //       dealerX = boxX - boxWidth / 4;
    //       dealerY = boxY + boxHeight / 2.5;
    //       chipsX = boxX - boxWidth * 0.9;
    //       chipsY = boxY - boxHeight / 3;
    //       break;
    //     }
    //     case "rb2": {
    //       boxX = initX + width / 2 + width / 5.2;
    //       boxY = initY + height / 1.44;
    //       dealerX = boxX - boxWidth / 2.3;
    //       dealerY = boxY - boxHeight / 8;
    //       chipsX = boxX - boxWidth * 0.8;
    //       chipsY = boxY - boxHeight / 1.1;
    //       break;
    //     }
    //   }
    // } else {
    switch (this.table.seats.length) {
      case 2: {
        seatPositions = this._2SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 3: {
        seatPositions = this._3SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 4: {
        seatPositions = this._4SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 5: {
        seatPositions = this._5SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 6: {
        seatPositions = this._6SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 7: {
        seatPositions = this._7SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 8: {
        seatPositions = this._8SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 9: {
        seatPositions = this._9SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
      case 10: {
        seatPositions = this._10SeatsPositionControls(
          width,
          height,
          initX,
          initY,
          seat,
          boxWidth,
          boxHeight
        );
        break;
      }
    }
    boxX = seatPositions.boxX;
    boxY = seatPositions.boxY;
    dealerX = seatPositions.dealerX;
    dealerY = seatPositions.dealerY;
    chipsX = seatPositions.chipsX;
    chipsY = seatPositions.chipsY;
    // }

    seat.box.setPosition(boxX, boxY);
    seat.playerBet.chips.setPosition(chipsX, chipsY);

    if (!reposition) seat.positionControls(width, height, initX, initY);
    else seat.reposition(width, height, initX, initY);
    seat.dealerX = dealerX;
    seat.dealerY = dealerY;
    // seat.dealer.positionControls(dealerSize, dealerX, dealerY);
  }
  _2SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "ct": {
        boxX = initX + width / 2;
        boxY = initY + height * 0.2;
        dealerX = boxX;
        dealerY = boxY + boxHeight * 0.9;
        chipsX = boxX + boxWidth * 0.45;
        chipsY = boxY + boxHeight * 0.55;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _3SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "lt1": {
        boxX = initX + boxWidth * 0.78;
        boxY = initY + height * 0.39;
        dealerX = boxX + boxWidth * 0.6;
        dealerY = boxY - boxHeight * 0.8;
        chipsX = boxX + boxWidth * 0.615;
        chipsY = boxY - boxHeight * 0.2;
        break;
      }
      case "rt1": {
        boxX = initX + width * 0.855;
        boxY = initY + height * 0.39;
        dealerX = boxX - boxWidth * 0.85;
        dealerY = boxY - boxHeight * 0.8;
        chipsX = boxX - boxWidth * 0.9;
        chipsY = boxY - boxHeight * 0.2;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _4SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "lt1": {
        boxX = initX + boxWidth * 0.65;
        boxY = initY + height * 0.51;
        dealerX = boxX + boxWidth * 0.4;
        dealerY = boxY + boxHeight * 0.6;
        chipsX = boxX + boxWidth * 0.6;
        chipsY = boxY - boxHeight * 0.1;
        break;
      }
      case "ct": {
        boxX = initX + width / 2;
        boxY = initY + height * 0.2;
        dealerX = boxX;
        dealerY = boxY + boxHeight * 0.9;
        chipsX = boxX + boxWidth * 0.45;
        chipsY = boxY + boxHeight * 0.55;
        break;
      }
      case "rt1": {
        boxX = initX + width * 0.89;
        boxY = initY + height * 0.51;
        dealerX = boxX - boxWidth * 0.6;
        dealerY = boxY + boxHeight * 0.6;
        chipsX = boxX - boxWidth * 0.9;
        chipsY = boxY - boxHeight * 0.1;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _5SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "lb1": {
        boxX = initX + boxWidth * 0.65;
        boxY = initY + height * 0.54;
        dealerX = boxX + boxWidth * 0.3;
        dealerY = boxY + boxHeight * 0.7;
        chipsX = boxX + boxWidth * 0.61;
        chipsY = boxY;
        break;
      }
      case "lt2": {
        boxX = initX + boxWidth * 1.23;
        boxY = initY + height * 0.275;
        dealerX = boxX + boxWidth * 0.4;
        dealerY = boxY + boxHeight * 0.65;
        chipsX = boxX + boxWidth * 0.6;
        chipsY = boxY + boxHeight * 0.05;
        break;
      }
      case "rt2": {
        boxX = initX + width * 0.782;
        boxY = initY + height * 0.275;
        dealerX = boxX - boxWidth * 0.55;
        dealerY = boxY + boxHeight * 0.65;
        chipsX = boxX - boxWidth * 0.85;
        chipsY = boxY + boxHeight * 0.05;
        break;
      }
      case "rb1": {
        boxX = initX + width * 0.89;
        boxY = initY + height * 0.54;
        dealerX = boxX - boxWidth * 0.5;
        dealerY = boxY + boxHeight * 0.7;
        chipsX = boxX - boxWidth * 0.85;
        chipsY = boxY;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _6SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "lb1": {
        boxX = initX + boxWidth * 0.62;
        boxY = initY + height * 0.6;
        dealerX = boxX + boxWidth * 0.3;
        dealerY = boxY + boxHeight * 0.72;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY - boxHeight * 0.06;
        break;
      }
      case "lt2": {
        boxX = initX + boxWidth * 0.95;
        boxY = initY + height * 0.365;
        dealerX = boxX + boxWidth * 0.5;
        dealerY = boxY + boxHeight * 0.52;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY - boxHeight * 0.15;
        break;
      }
      case "ct": {
        boxX = initX + width / 2;
        boxY = initY + height * 0.2;
        dealerX = boxX;
        dealerY = boxY + boxHeight * 0.9;
        chipsX = boxX + boxWidth * 0.45;
        chipsY = boxY + boxHeight * 0.55;
        break;
      }
      case "rt2": {
        boxX = initX + width * 0.845;
        boxY = initY + height * 0.365;
        dealerX = boxX - boxWidth * 0.8;
        dealerY = boxY + boxHeight * 0.52;
        chipsX = boxX - boxWidth * 0.86;
        chipsY = boxY - boxHeight * 0.15;
        break;
      }
      case "rb1": {
        boxX = initX + width * 0.89;
        boxY = initY + height * 0.6;
        dealerX = boxX - boxWidth * 0.7;
        dealerY = boxY + boxHeight * 0.72;
        chipsX = boxX - boxWidth * 0.86;
        chipsY = boxY - boxHeight * 0.06;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _7SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "lb2": {
        boxX = initX + boxWidth * 0.62;
        boxY = initY + height * 0.665;
        dealerX = boxX + boxWidth * 0.5;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX + boxWidth * 0.6;
        chipsY = boxY - boxHeight * 0.25;
        break;
      }
      case "lt1": {
        boxX = initX + boxWidth * 0.63;
        boxY = initY + height * 0.445;
        dealerX = boxX + boxWidth * 0.55;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX + boxWidth * 0.6;
        chipsY = boxY - boxHeight * 1.15;
        break;
      }
      case "ct": {
        boxX = initX + boxWidth * 1.39;
        boxY = initY + height * 0.275;
        dealerX = boxX + boxWidth * 0.25;
        dealerY = boxY + boxHeight * 0.75;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY;
        break;
      }
      case "rt2": {
        boxX = initX + width * 0.755;
        boxY = initY + height * 0.275;
        dealerX = boxX - boxWidth * 0.4;
        dealerY = boxY + boxHeight * 0.75;
        chipsX = boxX - boxWidth * 0.9;
        chipsY = boxY;
        break;
      }
      case "rt1": {
        boxX = initX + width * 0.9;
        boxY = initY + height * 0.445;
        dealerX = boxX - boxWidth * 0.6;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX - boxWidth * 0.9;
        chipsY = boxY - boxHeight * 1.15;
        break;
      }
      case "rb2": {
        boxX = initX + width * 0.892;
        boxY = initY + height * 0.665;
        dealerX = boxX - boxWidth * 0.8;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX - boxWidth * 0.85;
        chipsY = boxY - boxHeight * 0.25;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _8SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "lb2": {
        boxX = initX + boxWidth * 0.62;
        boxY = initY + height * 0.71;
        dealerX = boxX + boxWidth * 0.5;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY - boxHeight * 0.35;
        break;
      }
      case "lt1": {
        boxX = initX + boxWidth * 0.63;
        boxY = initY + height * 0.515;
        dealerX = boxX + boxWidth * 0.55;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY - boxHeight * 0.3;
        break;
      }
      case "lt2": {
        boxX = initX + boxWidth * 0.92;
        boxY = initY + height * 0.338;
        dealerX = boxX + boxWidth * 0.25;
        dealerY = boxY + boxHeight * 0.65;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY;
        break;
      }
      case "ct": {
        boxX = initX + width / 2;
        boxY = initY + height * 0.2;
        dealerX = boxX;
        dealerY = boxY + boxHeight * 0.9;
        chipsX = boxX + boxWidth * 0.45;
        chipsY = boxY + boxHeight * 0.55;
        break;
      }
      case "rt2": {
        boxX = initX + width * 0.832;
        boxY = initY + height * 0.338;
        dealerX = boxX - boxWidth * 0.7;
        dealerY = boxY + boxHeight * 0.75;
        chipsX = boxX - boxWidth * 0.85;
        chipsY = boxY;
        break;
      }
      case "rt1": {
        boxX = initX + width * 0.895;
        boxY = initY + height * 0.515;
        dealerX = boxX - boxWidth * 0.7;
        dealerY = boxY + boxHeight * 0.6;
        chipsX = boxX - boxWidth * 0.92;
        chipsY = boxY - boxHeight * 0.3;
        break;
      }
      case "rb1": {
        boxX = initX + width * 0.89;
        boxY = initY + height * 0.71;
        dealerX = boxX - boxWidth * 0.7;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX - boxWidth * 0.86;
        chipsY = boxY - boxHeight * 0.35;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _9SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        if (this.hasSelfPlayerSat()) {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.25;
          dealerX = boxX + boxWidth * 0.35;
          dealerY = boxY - boxHeight * 1.75;
          chipsX = boxX - boxWidth * 0.35;
          chipsY = boxY - boxHeight * 1.95;
        } else {
          boxX = initX + width / 2;
          boxY = initY + height - boxHeight * 2.9;
          dealerX = boxX + boxWidth * 0.45;
          dealerY = boxY - boxHeight * 2.25;
          chipsX = boxX - boxWidth * 0.45;
          chipsY = boxY - boxHeight * 2.55;
        }
        break;
      }
      case "lb2": {
        boxX = initX + boxWidth * 0.62;
        boxY = initY + height * 0.71;
        dealerX = boxX + boxWidth * 0.5;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY - boxHeight * 0.35;
        break;
      }
      case "lt1": {
        boxX = initX + boxWidth * 0.63;
        boxY = initY + height * 0.525;
        dealerX = boxX + boxWidth * 0.55;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX + boxWidth * 0.58;
        chipsY = boxY - boxHeight * 0.44;
        break;
      }
      case "lt2": {
        boxX = initX + boxWidth * 0.87;
        boxY = initY + height * 0.36;
        dealerX = boxX + boxWidth * 0.25;
        dealerY = boxY + boxHeight * 0.65;
        chipsX = boxX + boxWidth * 0.55;
        chipsY = boxY - boxHeight * 0.05;
        break;
      }
      case "ct": {
        boxX = initX + width * 0.365;
        boxY = initY + height * 0.2;
        dealerX = boxX;
        dealerY = boxY + boxHeight * 0.9;
        chipsX = boxX + boxWidth * 0.32;
        chipsY = boxY + boxHeight * 0.64;
        break;
      }
      case "rt2": {
        boxX = initX + width * 0.645;
        boxY = initY + height * 0.2;
        dealerX = boxX + boxWidth * 0.1;
        dealerY = boxY + boxHeight * 0.9;
        chipsX = boxX - boxWidth * 0.6;
        chipsY = boxY + boxHeight * 0.64;
        break;
      }
      case "rt1": {
        boxX = initX + width * 0.865;
        boxY = initY + height * 0.36;
        dealerX = boxX - boxWidth * 0.7;
        dealerY = boxY + boxHeight * 0.65;
        chipsX = boxX - boxWidth * 0.85;
        chipsY = boxY - boxHeight * 0.05;
        break;
      }
      case "rb1": {
        boxX = initX + width * 0.895;
        boxY = initY + height * 0.525;
        dealerX = boxX - boxWidth * 0.7;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX - boxWidth * 0.92;
        chipsY = boxY - boxHeight * 0.44;
        break;
      }
      case "rb2": {
        boxX = initX + width * 0.89;
        boxY = initY + height * 0.71;
        dealerX = boxX - boxWidth * 0.7;
        dealerY = boxY + boxHeight * 0.5;
        chipsX = boxX - boxWidth * 0.95;
        chipsY = boxY - boxHeight * 0.35;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
  _10SeatsPositionControls(
    width,
    height,
    initX,
    initY,
    seat,
    boxWidth,
    boxHeight
  ) {
    let boxX, boxY, dealerX, dealerY, chipsX, chipsY;
    switch (seat.position) {
      case "cb": {
        boxX = initX + (width - boxWidth) / 2;
        boxY = initY + height - boxHeight * 3.4;
        dealerX = boxX - boxWidth / 3.3;
        dealerY = boxY - boxHeight / 1.2;
        chipsX = boxX - boxWidth / 18;
        chipsY = boxY - boxHeight * 1.4;
        break;
      }
      case "lb2": {
        boxX = initX + boxWidth / 2.4;
        boxY = initY + height / 1.39;
        dealerX = boxX + boxWidth / 1.7;
        dealerY = boxY - boxHeight / 0.95;
        chipsX = boxX + boxWidth / 1.06;
        chipsY = boxY - boxHeight / 1.08;
        break;
      }
      case "lb1": {
        boxX = initX + boxWidth / 5.6;
        boxY = initY + height / 1.88;
        dealerX = boxX + boxWidth / 1.05;
        dealerY = boxY + boxHeight / 1.3;
        chipsX = boxX + boxWidth / 0.95;
        chipsY = boxY + boxHeight / 6.8;
        break;
      }
      case "lt1": {
        boxX = initX + boxWidth / 5.5;
        boxY = initY + height / 2.93;
        dealerX = boxX + boxWidth / 1.1;
        dealerY = boxY + boxHeight / 1.5;
        chipsX = boxX + boxWidth / 1.35;
        chipsY = boxY + boxHeight / 0.85;
        break;
      }
      case "lt2": {
        boxX = initX + boxWidth / 1.8;
        boxY = initY + height / 6.4;
        dealerX = boxX + boxWidth;
        dealerY = boxY + boxHeight / 2.4;
        chipsX = boxX + boxWidth / 1.5;
        chipsY = boxY + boxHeight / 1.25;
        break;
      }
      case "ct": {
        boxX = initX + (width - boxWidth) / 2;
        boxY = initY + height / 11.6;
        dealerX = boxX + boxWidth / 1.2;
        dealerY = boxY + boxHeight;
        chipsX = boxX - boxWidth / 19.1;
        chipsY = boxY + boxHeight / 0.75;
        break;
      }
      case "rt2": {
        boxX = initX + width / 1.32;
        boxY = initY + height / 6.4;
        dealerX = boxX - boxWidth / 5;
        dealerY = boxY + boxHeight / 0.8;
        chipsX = boxX - boxWidth / 0.95;
        chipsY = boxY + boxHeight / 1.25;
        break;
      }
      case "rt1": {
        boxX = initX + width / 2 + width / 3.23;
        boxY = initY + height / 2.93;
        dealerX = boxX - boxWidth / 4;
        dealerY = boxY + boxHeight / 1.5;
        chipsX = boxX - boxWidth / 1.26;
        chipsY = boxY + boxHeight / 0.85;
        break;
      }
      case "rb1": {
        boxX = initX + width / 1.23;
        boxY = initY + height / 1.88;
        dealerX = boxX - boxWidth / 3;
        dealerY = boxY + boxHeight / 1.3;
        chipsX = boxX - boxWidth / 0.9;
        chipsY = boxY + boxHeight / 6.8;
        break;
      }
      case "rb2": {
        boxX = initX + width / 1.3;
        boxY = initY + height / 1.39;
        dealerX = boxX - boxWidth / 2.2;
        dealerY = boxY - boxHeight / 3.9;
        chipsX = boxX - boxWidth / 1.2;
        chipsY = boxY - boxHeight / 0.95;
        break;
      }
    }
    return {
      boxX: boxX,
      boxY: boxY,
      dealerX: dealerX,
      dealerY: dealerY,
      chipsX: chipsX,
      chipsY: chipsY,
    };
  }
}
